import $ from 'jquery';
import Tooltip from 'root/module/tooltip';
import View from 'view/base';

var Modal_Fullscreen = {
    _overlay: null,
    _modal: null,

    _onclose: null,

    open: function(options) {
        Tooltip.removeAll();

        if (this._modal) {
            this._forceClose(true);
        }

        $(document.body).addClass('modal-open modal-fullscreen-open');

        if (!this._overlay) {
            this._overlay = $('<div>').addClass('overlay overlay-fullscreen');
            this._overlay.appendTo($(document.body));

            $(document).on('keyup', $.proxy(this._documentKeyup, this));
        }

        this._modal = $('<div>').addClass('modal modal-fullscreen');

        // close button
        $('<button>')
            .attr('type', 'button')
            .addClass('modal-button-close btn-close')
            .html('<i class="fa-regular fa-xmark"></i>')
            .on('click', this.close.bind(this))
            .appendTo(this._modal);

        // title
        $('<div>').addClass('modal-title').text(options.title || '').appendTo(this._modal);

        // content
        $('<div>').addClass('modal-content').html(options.content || '').appendTo(this._modal);

        // when the modal content is a backbone view, render it
        if (options.content instanceof View) {
            options.content.render().$el.appendTo(this._modal.find('.modal-content'));
        }

        if (options.onclose) {
            this._onclose = options.onclose;
        }

        if (options.nopadding) {
            this._modal.addClass('modal-nopadding');
        }

        if (options.theme) {
            this._modal.addClass(options.theme);
        }

        this._modal.appendTo(this._overlay);

        return this._modal;
    },

    close: function() {
        if (!this._modal) {
            return;
        }

        $(document.body).removeClass('modal-open modal-fullscreen-open');

        $(document).off('keyup', $.proxy(this._documentKeyup, this));

        if (this._onclose) {
            this._onclose(this._modal);
        }

        this._forceClose();
    },

    setTitle: function(title) {
        this._modal.find('.modal-title').text(title);
    },

    _documentKeyup: function(e) {
        if (e.which === 27) {
            this.close();
        }
    },

    _forceClose: function(skip_overlay) {
        if (this._modal) {
            this._modal.remove();
            this._modal = null;
        }

        if (skip_overlay !== true && this._overlay) {
            this._overlay.remove();
            this._overlay = null;
        }
    }
};

export default Modal_Fullscreen;
